const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
    api: "https://tdxddemo-api.cgis.asia/",
  },
  production: {
    api: "https://tdxddemo-api.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
